import React from 'react'
import { LinkProps, NavLink as NavLinkBase } from 'react-router-dom'
import { grey } from '@mui/material/colors'
import { ListItemButton, ListItemIcon, ListItemText } from '@mui/material'
import { PermissionRequirement } from '@cbgms/base/permissions/permissionsUtils'
import { useHasPermission } from 'app-support/permissions/RequiredPermissions'
import { InsufficientPermissionTooltip } from './InsufficientPermissionTooltip'
import LinkIcon from '@mui/icons-material/Link'

const NavLink = React.forwardRef<HTMLAnchorElement, LinkProps>((props, ref) => <NavLinkBase innerRef={ref as any} {...props} />)

export interface MenuItemProps {
  text: string
  url?: string
  permissions?: PermissionRequirement
  Icon?: React.ReactElement
  disabled?: boolean
  onClick?: () => void
  subItem?: boolean
}

const MenuItem: React.FC<MenuItemProps> = ({ Icon, url, permissions, text, disabled, onClick, subItem = false }) => {
  const [hasPermission] = useHasPermission(permissions || [])
  const Wrapper = !hasPermission ? InsufficientPermissionTooltip : React.Fragment

  const subItemStyling = subItem
    ? {
        pl: 4,
        py: 0.5,
        color: `${grey[400]}`
      }
    : { border: `1px solid ${grey[800]}`, borderWidth: '0 0 1px 0' }

  return (
    <Wrapper>
      <ListItemButton
        sx={{
          color: theme => theme.palette.getContrastText(theme.palette.common.black),
          '&:hover, &.active': { backgroundColor: grey[800], color: `${grey[100]} !important` },
          ...subItemStyling
        }}
        component={url ? NavLink : 'div'}
        to={url}
        data-testid='menu-list-item'
        disabled={disabled || !hasPermission}
        onClick={onClick}
      >
        <ListItemIcon sx={{ color: 'inherit', minWidth: '32px' }}>{Icon || <LinkIcon />}</ListItemIcon>
        <ListItemText primary={text} />
      </ListItemButton>
    </Wrapper>
  )
}

export default MenuItem
